import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { Badge, Button, Dropdown, Modal, Table } from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import { fullBackendPath } from 'core/helpers';
import { ICON_MORE } from '@services/constant';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { services, updateData, deleteData, updating } = props;

  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const [modalType, setModalType] = useState('create');
  const [itemUpdate, setItemUpdate] = useState();
  const [name, setName] = useState('');
  const [describe, setDescribe] = useState('');
  const [shortDescribe, setShortDescribe] = useState('');
  const [background, setBackground] = useState(null);

  useEffect(() => {
    if (!showModal) {
      setItemUpdate(null);
      setName('');
      setDescribe('');
      setShortDescribe('');
      setBackground(null);
    }
  }, [showModal]);

  const onClickShowModalCreate = () => {
    setModalType('create');
    setName('');
    setDescribe('');
    setShortDescribe('');
    setBackground(null);
    setShowModal(true);
  };

  const onClickShowModalEdit = (item, isEdit = true) => {
    const { name, describe, short_describe } = item;

    isEdit && setModalType('Edit');
    setItemUpdate(item);
    setName(name);
    setDescribe(describe);
    setShortDescribe(short_describe);
    setBackground(null);
    isEdit ? setShowModal(true) : setShowModalDetail(true);
  };

  const onClickDelete = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        deleteData(
          item.id,
          `service/${item.id}`,
          'services',
          (isError, error) => {
            if (isError) {
              notifyError(error);
            } else {
              notifySuccess('Delete successfully');
            }
          }
        );
      }
    });
  };

  const onSubmit = () => {
    const method = modalType === 'create' ? 'post' : 'put';
    const url = modalType === 'create' ? 'service' : `service/${itemUpdate.id}`;

    const params = {
      name,
      describe,
      short_describe: shortDescribe,
      images: [],
    };

    if (background)
      params.images.push({
        field: 'service_background',
        image: background,
      });

    updateData(method, url, params, 'services', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess(
          method === 'post' ? 'Create successfully' : 'Update successfully'
        );
      }
    });
  };

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModalCreate} className="btn btn-success">
          Create
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List Services</h4>
            </div>
            <div className="card-body position-relative">
              {updating && !showModal && <PageLoader />}
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Short describe</strong>
                    </th>
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th className="action-column">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {services?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {index + 1}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {item.name}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {item.short_describe}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                          style={{ width: '30%' }}
                        >
                          {item.service_background?.path && (
                            <img
                              width={'100%'}
                              height={200}
                              style={{ objectFit: 'contain' }}
                              src={fullBackendPath(
                                item.service_background.path
                              )}
                            />
                          )}
                        </td>
                        <td className="action-column">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              className="light sharp i-false"
                            >
                              {ICON_MORE}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => onClickShowModalEdit(item)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => onClickDelete(item)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              {modalType === 'create' ? 'Create' : 'Edit'}
            </Modal.Title>
            <Button
              variant=""
              className="btn-close"
              disabled={updating}
              onClick={() => setShowModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            {updating && <PageLoader />}
            <div className="form-group">
              <label className="form-label">Name</label>
              <input
                className="form-control"
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Short describe</label>
              <input
                className="form-control"
                type="text"
                id="short_describe"
                value={shortDescribe}
                onChange={(e) => setShortDescribe(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Describe</label>
              <Editor value={describe} onChange={setDescribe} />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Background image</label>
              <input
                className="form-control"
                type="file"
                id="service_background"
                accept="image/png, image/jpeg"
                onChange={(e) => setBackground(e.target.files[0])}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={updating}
              variant="danger light"
              onClick={() => setShowModal(false)}
            >
              Close
            </Button>
            <Button
              disabled={updating}
              variant=""
              type="submit"
              className="btn btn-primary"
            >
              {modalType === 'create' ? 'Create' : 'Update'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        className="fade"
        enforceFocus={false}
        show={showModalDetail}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Detail</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setShowModalDetail(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              className="form-control"
              type="text"
              id="name"
              value={name}
              disabled
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Short describe</label>
            <input
              className="form-control"
              type="text"
              id="short_describe"
              value={shortDescribe}
              disabled
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Describe</label>
            <Editor value={describe} disabled />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Background image</label>
            {itemUpdate?.service_background?.path && (
              <img
                className="img-responsive"
                width={'100%'}
                src={fullBackendPath(itemUpdate?.service_background?.path)}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={updating}
            variant="danger light"
            onClick={() => setShowModalDetail(false)}
          >
            Close
          </Button>
          <Button
            variant=""
            className="btn btn-primary"
            onClick={() => {
              setShowModalDetail(false);
              onClickShowModalEdit(itemUpdate);
            }}
          >
            Edit
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  services: state.admin.services,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
  deleteData: (id, url, field, callback) =>
    dispatch(AdminActions.deleteData(id, url, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
